module.exports = __webpack_public_path__ + "img/medMission_041022_B.a5e73502.jpg";